import type { FaireProductEntity } from "../../entity_types/product";

export const p_7kyzzwnwue: FaireProductEntity = {
  token: "p_7kyzzwnwue",
  type: "product",
  name: "Golden Mama Necklace",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/3753b180ed5bae5884bb5ca88d6432ad381f605d378e3fd7026798a7d7ba6810.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8b38bc7535e1ccd205271e284e38be75845b58c86ae07eb8827db4942578b7b1.jpeg",
    "https://cdn.faire.com/fastly/54facab77c3b6358bda49ea85a10a6efc47ec89cb5702a868356faa4eb3f2c19.jpeg",
    "https://cdn.faire.com/fastly/85edbd4e41a8dc50a5590a3ef327665d382345c2fa0b61cdffdb79f774652e63.jpeg",
  ],
  priceDollars: 8.24,
  description:
    "Simple and chic MAMA necklace.\n\n16 inch chain with a 2 inch extender\n\nGold plated Stainless Steel that last long with no tarnish\n\nLead and Nickel Free\n\nMade in China\n",
  tags: [],
  msrpDollars: 23.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:37.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
